import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NumericInput from './components/NumericInput';
import DateInputGroup from './components/DateInputGroup';

const BookingWidget = ({
  endpoint,
  adultCountLabel,
  adultCountPlaceholder,
  childCountLabel,
  childCountPlaceholder,
  startDateLabel,
  startDatePlaceholder,
  endDateLabel,
  endDatePlaceholder,
  buttonLabel,
  salesId,
  productSupercategoryId,
  ascSasCampaign,
  nck,
  supplierIds,
  packageId,
  promoCode,
  sticky: shoudStick
}) => {
  const ref = useRef();
  const [adultCount, setAdultCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    if (!shoudStick || shoudStick === 'False' || shoudStick === 'false') {
      return;
    }

    const handleScroll = () => {
      if (ref.current) {
        const { scrollY, innerHeight } = window;
        const { offsetTop, offsetHeight } = ref.current;

        if (scrollY + innerHeight < offsetTop + offsetHeight + 44) {
          setSticky(true);
        } else {
          setSticky(false);
        }
      }
    };

    document.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => document.removeEventListener('scroll', handleScroll);
  }, [ref, shoudStick]);

  const handleDateChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  return (
    <div
      ref={ref}
      className={classNames('booking-widget__form', {
        'booking-widget__form--sticky': sticky
      })}
    >
      <div className="booking-widget__form-inner">
        <form method="GET" action={endpoint} target="_blank">
          <div className="booking-widget__input">
            <NumericInput
              placeholder={adultCountPlaceholder}
              label={adultCountLabel}
              name="adultcount"
              value={adultCount}
              maxValue={6}
              onChange={setAdultCount}
            />
          </div>
          <div className="booking-widget__input">
            <NumericInput
              placeholder={childCountPlaceholder}
              label={childCountLabel}
              name="childcount"
              value={childCount}
              maxValue={7}
              onChange={setChildCount}
            />
          </div>

          <DateInputGroup
            startDateName="arrivaldate"
            startDateLabel={startDateLabel}
            startDatePlaceholder={startDatePlaceholder}
            endDateName="departuredate"
            endDateLabel={endDateLabel}
            endDatePlaceholder={endDatePlaceholder}
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateChange}
          />

          {!!salesId && <input type="hidden" value={salesId} name="salesid" />}

          {!!productSupercategoryId && (
            <input
              type="hidden"
              value={productSupercategoryId}
              name="productsupercategoryid"
            />
          )}

          {!!ascSasCampaign && (
            <input
              type="hidden"
              value={ascSasCampaign}
              name="asc_sas_campaign"
            />
          )}

          {!!nck && <input type="hidden" value={nck} name="NCK" />}

          {!!supplierIds && (
            <input type="hidden" value={supplierIds} name="supplierId" />
          )}

          {!!packageId && (
            <input type="hidden" value={packageId} name="package" />
          )}

          {!!promoCode && <input type="hidden" value={promoCode} name="code" />}

          <button
            className="btn btn--primary booking-widget__submit"
            type="submit"
          >
            {buttonLabel}
          </button>
        </form>
      </div>
    </div>
  );
};

BookingWidget.propTypes = {
  endpoint: PropTypes.string.isRequired,
  adultCountLabel: PropTypes.string.isRequired,
  adultCountPlaceholder: PropTypes.string,
  childCountLabel: PropTypes.string.isRequired,
  childCountPlaceholder: PropTypes.string,
  startDateLabel: PropTypes.string.isRequired,
  startDatePlaceholder: PropTypes.string.isRequired,
  endDateLabel: PropTypes.string.isRequired,
  endDatePlaceholder: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  salesId: PropTypes.string,
  productSupercategoryId: PropTypes.string,
  ascSasCampaign: PropTypes.string,
  nck: PropTypes.string,
  supplierIds: PropTypes.string,
  packageId: PropTypes.string,
  promoCode: PropTypes.string,
  sticky: PropTypes.string
};

export default BookingWidget;
